import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Message — lays out a single conversation message (alignment + avatar slot).
 * For AI apps this is where assistant text, reasoning steps and tool calls go.
 */
export interface MessageProps extends React.HTMLAttributes<HTMLDivElement> {
  role?: 'user' | 'assistant';
}

export const Message = React.forwardRef<HTMLDivElement, MessageProps>(
  ({ className, role = 'assistant', children, ...props }, ref) => (
    <div
      ref={ref}
      data-role={role}
      className={cn(
        'tw:flex tw:w-full tw:items-end tw:gap-2 tw:py-1',
        role === 'user' ? 'tw:justify-end' : 'tw:justify-start',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);
Message.displayName = 'Message';
